import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './header.scss';

// Assets
// ---------------------
import GoldmanSachsLogo from '../../assets/images/GS_Signature_Mono.png';

// Icons
// ---------------------
import { ReactComponent as MenuIcon } from '../../assets/icons/menu_black_24dp.svg';
import { ReactComponent as ChevronIcon } from '../../assets/icons/chevron_left_black_24dp.svg';
import { ReactComponent as CloseIcon } from '../../assets/icons/close_black_24dp.svg';

// Handle Dropdown State
// ---------------------
export const useDropdownClickHandler = (ref, initialState) => {
  const [isActive, setIsActive] = useState(initialState);

  useEffect(() => {
    const pageClickEvent = (e) => {
      if (ref.current !== null && !ref.current.contains(e.target)) {
        setIsActive(false);
      }
    };
    if (isActive) {
      window.addEventListener('click', pageClickEvent);
    }
    return () => {
      window.removeEventListener('click', pageClickEvent);
    };
  }, [isActive, ref]);
  return [isActive, setIsActive];
};

export const Header = ({ currentPage, ...props }) => {
  const dropdownRef = useRef(null);
  const [isDropDownActive, setIsDropDownActive] = useDropdownClickHandler(
    dropdownRef,
    false
  );
  const onClickDropdown = () => setIsDropDownActive(!isDropDownActive);

  // Menu ESC Handling
  // ---------------------

  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        if (isDropDownActive) {
          setIsDropDownActive(false);
        }
      }
    };
    document.addEventListener('keydown', keyDownHandler);
    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [isDropDownActive, setIsDropDownActive]);

  // Dropdown Menu
  // ---------------------
  const dropdownMenu = [
    { item: 'Overview', path: '/sigmaxmtf/overview' },
    {
      item: 'Becoming a Participant',
      path: '/sigmaxmtf/becoming-a-participant',
    },
    {
      item: 'Participant Information',
      path: '/sigmaxmtf/participant-information',
    },
    { item: 'News & Updates', path: '/sigmaxmtf/news' },
    { item: 'Contact Us', path: '/sigmaxmtf/contact' },
  ];

  for (let i = 0; i < dropdownMenu.length; i++) {
    if (dropdownMenu[i].item === currentPage) {
      dropdownMenu[i].current = true;
      break;
    }
  }
  // ---------------------

  return (
    <div className={`header-component`}>
      <div className="header-wrapper">
        <div className="header-logo">
          <a href={dropdownMenu[0].path}>
            <img src={GoldmanSachsLogo} alt="Goldman Sachs Logo" />
          </a>
        </div>
        {/* <div className="header-search">
          <input
            type="text"
            className="search-text stripped-input"
            placeholder={currentPage}
            aria-label="Search Input"
          ></input>
          <button
            type="submit"
            className="icon stripped-button"
            aria-label="Search"
          >
            <SearchIcon />
          </button>
        </div> */}
        <div ref={dropdownRef} className="header-menu">
          <button
            className="icon stripped-button"
            onClick={onClickDropdown}
            aria-expanded={isDropDownActive}
            aria-label="Dropdown Menu"
          >
            <MenuIcon className={isDropDownActive ? 'display-none' : ''} />
            <CloseIcon className={!isDropDownActive ? 'display-none' : ''} />
          </button>
          <div className={`menu-panel ${isDropDownActive ? 'active' : ''}`}>
            <ul className="menu-items">
              {dropdownMenu.map((item, i) => {
                return (
                  <li key={'dropdown-' + i}>
                    <a
                      className="menu-item"
                      href={item.path}
                      aria-current={item.current ? 'page' : 'false'}
                    >
                      <ChevronIcon />
                      <span>{item.item}</span>
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

Header.propTypes = {
  currentPage: PropTypes.string,
};
